import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set document title and meta tags for SEO
if (typeof document !== 'undefined') {
  document.title = 'Absolute Insurance Brokers | NAICOM Certified Insurance Solutions Nigeria';
  // Create meta tags
  const metaTags = [{
    name: 'description',
    content: 'Absolute Insurance Brokers - NAICOM certified insurance brokerage offering comprehensive life, health, auto, and business insurance solutions in Nigeria. Expert risk management and claims advocacy.'
  }, {
    name: 'keywords',
    content: 'insurance broker Nigeria, NAICOM certified, life insurance, health insurance, auto insurance, business insurance, risk management, claims management, insurance solutions Nigeria'
  }, {
    name: 'author',
    content: 'Absolute Insurance Brokers'
  }, {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1.0'
  }, {
    name: 'robots',
    content: 'index, follow'
  }, {
    name: 'language',
    content: 'English'
  }, {
    name: 'revisit-after',
    content: '7 days'
  },
  // Open Graph / Facebook
  {
    property: 'og:type',
    content: 'website'
  }, {
    property: 'og:url',
    content: 'https://absoluteinsurancebrokers.com/'
  }, {
    property: 'og:title',
    content: 'Absolute Insurance Brokers | NAICOM Certified Insurance Solutions'
  }, {
    property: 'og:description',
    content: 'Expert insurance brokerage services in Nigeria. Comprehensive coverage for life, health, auto, and business with award-winning service.'
  }, {
    property: 'og:image',
    content: 'https://cdn.magicpatterns.com/uploads/woWdE3SqvP2mw6xTq283GZ/Screenshot_2025-12-07_085625.png'
  },
  // Twitter
  {
    name: 'twitter:card',
    content: 'summary_large_image'
  }, {
    name: 'twitter:url',
    content: 'https://absoluteinsurancebrokers.com/'
  }, {
    name: 'twitter:title',
    content: 'Absolute Insurance Brokers | NAICOM Certified Insurance Solutions'
  }, {
    name: 'twitter:description',
    content: 'Expert insurance brokerage services in Nigeria. Comprehensive coverage for life, health, auto, and business.'
  }, {
    name: 'twitter:image',
    content: 'https://cdn.magicpatterns.com/uploads/woWdE3SqvP2mw6xTq283GZ/Screenshot_2025-12-07_085625.png'
  }];
  metaTags.forEach(tag => {
    const meta = document.createElement('meta');
    if (tag.name) meta.setAttribute('name', tag.name);
    if (tag.property) meta.setAttribute('property', tag.property);
    meta.setAttribute('content', tag.content);
    document.head.appendChild(meta);
  });
  // Add canonical link
  const canonical = document.createElement('link');
  canonical.setAttribute('rel', 'canonical');
  canonical.setAttribute('href', 'https://absoluteinsurancebrokers.com/');
  document.head.appendChild(canonical);
  // Add structured data (JSON-LD) for SEO
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'InsuranceAgency',
    name: 'Absolute Insurance Brokers',
    image: 'https://cdn.magicpatterns.com/uploads/woWdE3SqvP2mw6xTq283GZ/Screenshot_2025-12-07_085625.png',
    description: 'NAICOM certified insurance brokerage offering comprehensive insurance solutions including life, health, auto, and business insurance in Nigeria.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'NG',
      addressLocality: 'Nigeria'
    },
    url: 'https://absoluteinsurancebrokers.com/',
    telephone: '+234-XXX-XXX-XXXX',
    priceRange: '$$',
    areaServed: {
      '@type': 'Country',
      name: 'Nigeria'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Insurance Services',
      itemListElement: [{
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Life Insurance',
          description: 'Group Life Insurance, Group Mortgage Protection, Credit Life Insurance, Health Insurance'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'General Insurance',
          description: 'Burglary/Theft, Fire & Special Perils, Business Interruption, Machinery Breakdown, Public/Product Liability, and more'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Risk Management Advisory',
          description: 'Strategic consulting to minimize risk exposure and optimize insurance portfolio'
        }
      }]
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      reviewCount: '150'
    },
    award: 'NAICOM Certified Insurance Broker'
  };
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(structuredData);
  document.head.appendChild(script);
}
render(<App data-id="element-370" />, document.getElementById('root'));